<template>
    <v-dialog
        v-model="showDialog"
        width="900"
    >
        <v-form
            ref="form"
            @submit.prevent="submitForm"
        >
            <v-card elevation="10">
                <v-card-title style="background-color: #009688; color: white; word-wrap: normal;">
                    Generate Letter Report
                    <v-spacer />
                    <v-btn text color="white" @click="showDialog = !showDialog">
                        close
                    </v-btn>
                </v-card-title>
                <v-card-text style="padding-top: 20px;">
                    <div>
                        <v-autocomplete
                            v-model="data.EMPLOYEE"
                            :items="preparedByList"
                            label="Employee Name"
                            outlined
                            style="display:inline-block; margin-left:10px"
                        />
                        <v-text-field
                            v-model="data.FR_DATE"
                            label="Start Date"
                            type="date"
                            outlined
                            style="display:inline-block; margin-left:10px"
                        />
                        <v-text-field
                            v-model="data.TO_DATE"
                            label="End Date"
                            type="date"
                            outlined
                            style="display:inline-block; margin-left:10px"
                        />
                        <v-btn
                            class="white--text"
                            color="teal darken-1"
                            :loading="loading"
                            style="margin-left:10px; height:55px; align-self:flex-start;"
                            type="submit"
                        >
                            generate report
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { saveAs } from 'file-saver'
import { moment } from '../../../../../../utils/date-shim'
import { mapGetters, mapActions } from 'vuex'
import { base64ToBlob } from '../../../../../../utils/helpers'

export default {
    props: ['show', 'notif', 'screen_width'],
    data:()=>({
        preparedByList: ['ALL'],
        loading: false,
        data: {
            FR_DATE: null,
            TO_DATE: null,
            EMPLOYEE: 'ALL'
        },
        sign: { status: false },
        hovering: false,
        search: {
            value: null,
            query: null
        }
    }),
    computed: {
        ...mapGetters(['generateLetterReportData', 'listEndorsementConfirmationData']),
        showDialog: {
            get() {
                this.setDate()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        listEndorsementConfirmationData(newVal) {
            if (newVal && newVal.status === 200) {
                this.preparedByList = [...new Set(newVal.data.map(item => item['PREPARED BY']))].sort((a, b) => a.localeCompare(b))
                this.preparedByList.unshift('ALL')
            }
        },
        generateLetterReportData(newVal) {
            this.loading = false
            if (newVal) {
                if (newVal.status === 200) {
                    this.handleFileDownload(newVal.data, `LetterReport${this.data.FR_DATE}-${this.data.TO_DATE}.xlsx`)
                }
            }
        },
        'search.query'(newVal) {
            if (newVal === '') {
                this.search.value = null
            }
        }
    },
    methods: {
        ...mapActions(['generateLetterReport']),
        setDate() {
            this.data.TO_DATE = moment().format('YYYY-MM-DD')
            this.data.FR_DATE = moment().subtract(5, 'days').format('YYYY-MM-DD')
        },
        handleFileDownload(data, fileName) {
            try {
                const blob = base64ToBlob(data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                saveAs(blob, fileName)
            } catch (error) {
                // console.error('handleFileDownload error: ', error)
            }
        },
        submitForm() {
            if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                this.loading = true
                this.generateLetterReport(this.data)
            }
        }
    }
}
</script>

<style scoped>
.reportPage {
    padding-top: 20px;
}
</style>
